<template>
<div class="animated fadeIn">
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="6">
          <span class="float-left card-title wise-card-title">Total Level Result </span>
          <reachHelpResult01></reachHelpResult01>
          <reachHelpResult02></reachHelpResult02>
        </b-col>
        <b-col sm="6">
          <span class="float-right">
            <b-button block variant="outline-primary" class="btn-pill" @click="totalLevelChartChangeFn">
              <span style="font-weight:900;">{{totalLevelChartChangeLable}}</span>
            </b-button>
          </span>
          <reachHelpResult03></reachHelpResult03>
        </b-col>
        <b-col sm="5">
          <br/>
          <b-card class="text-white bg-success">
            <span class="h4 m-0" style="padding-right:20px">총예산 | </span>
            <span class="h2 m-0">{{formData.totalBudget | separator}}만원</span>
          </b-card>
          <b-card class="text-white bg-success">
            <span class="h4 m-0" style="padding-right:20px">타겟 | </span>
            <span class="h2 m-0">{{formData.targetCode}}({{formData.demographic_cnt | separator}})</span>
          </b-card>
          <b-card class="text-white bg-primary">
            <span class="h4 m-0" style="padding-right:10px">Reach 1+ | </span>
            <span class="h2 m-0" style="padding-right:50px">{{totalMedia.resultMedia.reach1 | numeral('0.00')}}</span>
          </b-card>
          <b-card class="text-white bg-primary">
            <span class="h4 m-0" style="padding-right:10px">Total GRPS | </span>
            <span class="h2 m-0" style="padding-right:50px">{{totalMedia.resultMedia.grps | numeral('0.00')}}</span>
            <span class="h4 m-0" style="padding-right:10px">A.F | </span>
            <span class="h2 m-0">{{totalMedia.resultMedia.grps / totalMedia.resultMedia.reach1 | numeral('0.00')}}</span>
          </b-card>
        </b-col>
        <b-col sm="1">
        </b-col>
        <b-col v-if="!showResult" sm="6" >
          <loading></loading>
        </b-col>
        <div  v-show="showResult">
          <b-col sm="6" v-show="totalLevelChartChange" class="animated fadeIn">
            <div id="mediaLevel_TOTAL_Venn1"></div>
          </b-col>
          <b-col sm="6" v-show="!totalLevelChartChange" class="animated fadeIn">
            <div id="txt3" ></div>
            <div id="mediaLevel_TOTAL_Venn2" >
            </div>
          </b-col>
        </div>
      </b-row>
    </div>
  </b-card>
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="12">
          <span class="card-title wise-card-title">Media Level Result </span>
          <span class="small text-muted wise-card-subtitle"> Media Level Result</span>
          <span class="float-right">
            <b-form-group>
              <b-form-radio-group v-model="channelDiagramType">
                <b-form-radio value="A" selected>Facebook + GDN</b-form-radio>
                <b-form-radio value="B">Naver + Kakao</b-form-radio>
                <b-form-radio value="C">(FB+GDN) + (Naver+Kakao)</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </span>
        </b-col>
        <b-col sm="6">
          <br/>
          <table  id="mediaTable"
                  data-search="false"
                  data-show-columns="false"
                  data-pagination="false"
                  data-detail-view="true"
                  data-detail-formatter="detailFormatter"
                  >
              <thead>
                  <tr>
                      <th data-field="media">미디어</th>
                      <th data-field="target">output 타겟</th>
                      <th data-field="budgetLabel">예산(만원)</th>
                      <th data-field="cpmLabel">CPM</th>
                      <th data-field="grps">GRPs</th>
                      <th data-field="reach1" >Reach 1+</th>
                      <th data-field="af" >A.F</th>
                  </tr>
              </thead>
          </table>
        </b-col>
        <b-col v-if="!showResult" sm="6" >
          <loading></loading>
        </b-col>
        <div v-show="showResult" sm="6">
          <div v-show="pcMediaShow">
            <b-col sm="12" v-show="channelDiagramType == 'A'" class="animated fadeIn">
              <div id="mediaLevel_PC_VennA">
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'B'" class="animated fadeIn">
              <div id="mediaLevel_PC_VennB" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'C'" class="animated fadeIn">
              <div id="mediaLevel_PC_VennC" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
          </div>
          <div v-show="mobileMediaShow">
            <b-col sm="12" v-show="channelDiagramType == 'A'" class="animated fadeIn">
              <div id="mediaLevel_Mobile_VennA">
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'B'" class="animated fadeIn">
              <div id="mediaLevel_Mobile_VennB" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'C'" class="animated fadeIn">
              <div id="mediaLevel_Mobile_VennC" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
          </div>
          <div v-show="digitalMediaShow">
            <b-col sm="12" v-show="channelDiagramType == 'A'" class="animated fadeIn">
              <div id="mediaLevel_Digital_VennA">
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'B'" class="animated fadeIn">
              <div id="mediaLevel_Digital_VennB" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
            <b-col sm="12" v-show="channelDiagramType == 'C'" class="animated fadeIn">
              <div id="mediaLevel_Digital_VennC" >
                <div class="noData">데이터가 없습니다.</div>
              </div>
            </b-col>
          </div>
        </div>
      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>
import reachFormData from "../../../common/ReachFormData.js";
import mediaLevelChart from "./mediaLevelChart.js";
import bootstrapTable from "bootstrap-table";
import select2 from "select2/dist/js/select2.full.min.js";
import * as venn from "venn.js/build/venn.js";
import * as d3 from "d3v4/build/d3.min.js";
import reach3Logic from "../../../common/Reach3Logic.js";
import reachHelpResult01 from "../../../helpModals/reach/reachHelpResult01.vue";
import reachHelpResult02 from "../../../helpModals/reach/reachHelpResult02.vue";
import reachHelpResult03 from "../../../helpModals/reach/reachHelpResult03.vue";
import loading from '../../../common/blockLoading.vue'; // 로딩중
import daInteLogic from '../../../common/DAInteLogic.js';

export default {
  components : {
  'reachHelpResult01' : reachHelpResult01,
  'reachHelpResult02' : reachHelpResult02,
  'reachHelpResult03' : reachHelpResult03,
  'loading' : loading,
  'daInteLogic' : daInteLogic
  },
  props: {
    rootFormData:null,
  },
  // index_data
  data() {
    return {
      showResult : false,
      formData: this.$_.clone(this.$session.get('inputFormData')),
      constFormData: this.$_.clone(this.$session.get('inputFormData').mediaListResult),
      chartData: [],
      inte_cffcnt:{},
      inte_cffcnt_N:{},
      tableData: null,
      channelDiagramType:'A',
      // graphIndex:0,
      mobileMedia :{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        // screenCount: 1,
        vennMediaData:{
          AVennDiagram:{ // FB + GDN
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          BVennDiagram:{ // Kakao + Naver
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          CVennDiagram:{ // (FB/GDN) + (Kakao/Naver)
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
        },
      },
      pcMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        // screenCount: 1,
        vennMediaData:{
          AVennDiagram:{ // FB + GDN
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          BVennDiagram:{ // Kakao + Naver
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          CVennDiagram:{ // (FB/GDN) + (Kakao/Naver)
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
        },
      },
      digitalMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        vennMediaData:{
          AVennDiagram:{ // FB + GDN
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          BVennDiagram:{ // Kakao + Naver
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
          CVennDiagram:{ // (FB/GDN) + (Kakao/Naver)
            resultMedia:this.$_.clone(reachFormData.mediaInfo),
          },
        },
      },
      totalMedia:{
        resultMedia:this.$_.clone(reachFormData.mediaInfo),
      },
      vennMediaData:{
        AVennDiagram:{ // FB + GDN
          resultMedia:this.$_.clone(reachFormData.mediaInfo),
        },
        BVennDiagram:{ // Kakao + Naver
          resultMedia:this.$_.clone(reachFormData.mediaInfo),
        },
        CVennDiagram:{ // (FB/GDN) + (Kakao/Naver)
          resultMedia:this.$_.clone(reachFormData.mediaInfo),
        },
      },
      mediaProcessingFlag:0,
      chartChangeLable:'교집합 벤다이어그램',
      totalLevelChartChangeLable:'교집합 벤다이어그램',
      chartChange:true,
      tvMediaShow:false,
      pcMediaShow:false,
      mobileMediaShow:false,
      digitalMediaShow:false,
      completeMediaLevelCalculation:false,
      totalLevelCode:'',
      totalLevelChartChange:true
    }
  }
  ,
  created: function() {}
  ,
  updated: function() {}
  ,
  mounted: function() {
    this.showResult = false;
    for(var i=0; i<this.formData.mediaListResult.length; i++) {
      this.formData.mediaListResult[i].eImp = this.formData.mediaListResult[i].outputImpression;
      this.formData.mediaListResult[i].outputTargetCode = this.formData.targetCode;
    }
  }
  ,
  watch:{
     // index_pre 이전레벨인 채널레벨의 결과분석이 끝나면 현재레벨인 미디어 레벨의 결과 분석 시작
    'rootFormData.completeChannelLevelCalculcation' : function(){
      this.classifyMedia(); // 시작점
    },
    // index_4 결과 데이터 만들기 (table / VennDiagram ... )
    'mediaProcessingFlag': function(){
      if(this.mediaProcessingFlag >= 4){
        this.makeFinalMediaList();
      }
    },
    // index_6 토탈레벨 분석
    'completeMediaLevelCalculation':function(){
      if(this.completeMediaLevelCalculation){
        // index_6-1 토탈레벨 분석코드 생성
        this.showResult = true;
      }
      this.rootFormData.totalMedia = this.totalMedia; // 2018-10-22 엑셀다운로드를 위해서 추가
    }
  },
  methods: {
    handleResize() {
      $('#mediaTable').bootstrapTable('resetView');
    },
    getInteCffcnt(){
      var token = sessionStorage.getItem("myToken");
      // DA
      this.$http.get('/api/select/allInteCffcntN?access_token='+token)
        .then((result) => {
          var list = result.data;
          for(var i=0; i<list.length; i++){
            this.inte_cffcnt_N[list[i].int_CFFCNT_CD] = list[i];
          }
      });
    },
    // 시작점 ... index_1 미디어 내부 채널 분류 (overall, 채널 , 기타매체)
    classifyMedia() {
      var channelLevelResult = this.rootFormData.channelLevelResultForMedia;
      this.$log.debug('Media Level Result 분석시작 ========== ');
      this.$log.debug('Media Level Result channelLevelResult 객체값 : ', channelLevelResult);

      var pcGRPs = 0.0;
      var mobileGRPs = 0.0;
      var digitalGRPs = 0.0;

      for(var i=0; i <channelLevelResult.length; i++){
        channelLevelResult[i].reach1 = parseFloat(channelLevelResult[i].reach1);
        channelLevelResult[i].lmt = parseFloat(channelLevelResult[i].lmt);

        switch(channelLevelResult[i].media) {
            case 'PC':
                pcGRPs += parseFloat(channelLevelResult[i].grps);
                if(channelLevelResult[i].channel == '전체'){
                    this.pcMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                }else {
                  this.pcMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                  this.pcMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            case 'Mobile':
                mobileGRPs += parseFloat(channelLevelResult[i].grps);
                if(channelLevelResult[i].channel == '전체'){
                    this.mobileMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                }else{
                  this.mobileMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                  this.mobileMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            case 'Digital':
                digitalGRPs += parseFloat(channelLevelResult[i].grps);
                if(channelLevelResult[i].channel == '전체'){
                    this.digitalMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                }else {
                  this.digitalMedia.resultMedia = this.$_.clone(channelLevelResult[i]); // 임시
                  this.digitalMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            }
          }
      daInteLogic.channelInteCalc(this.pcMedia, pcGRPs, this.pcMedia.vennMediaData);
      daInteLogic.channelInteCalc(this.mobileMedia, mobileGRPs, this.mobileMedia.vennMediaData);
      daInteLogic.channelInteCalc(this.digitalMedia, digitalGRPs, this.digitalMedia.vennMediaData);

      this.makeFinalMediaList();
      this.calcTotalLevel();
    },
    makeFinalMediaList(){
      var combindMediaList = [];
      if(this.pcMedia.resultMedia !== null){
        switch (this.pcMedia.vennMediaData.AVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.pcMedia.vennMediaData.AVennDiagram, 'PC', '_VennA');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.pcMedia.vennMediaData.AVennDiagram, 'PC', '_VennA');
            break;
        }
        switch (this.pcMedia.vennMediaData.BVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.pcMedia.vennMediaData.BVennDiagram, 'PC', '_VennB');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.pcMedia.vennMediaData.BVennDiagram, 'PC', '_VennB');
            break;
        }
        switch (this.pcMedia.vennMediaData.CVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.pcMedia.vennMediaData.CVennDiagram, 'PC', '_VennC');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.pcMedia.vennMediaData.CVennDiagram, 'PC', '_VennC');
            break;
        }
        combindMediaList.push(this.pcMedia.resultMedia);
      }
      if(this.mobileMedia.resultMedia !== null){
        switch (this.mobileMedia.vennMediaData.AVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램 resultMedia
            this.make1ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.AVennDiagram, 'Mobile', '_VennA');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.AVennDiagram, 'Mobile', '_VennA');
            break;
        }
        switch (this.mobileMedia.vennMediaData.BVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.BVennDiagram, 'Mobile', '_VennB');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.BVennDiagram, 'Mobile', '_VennB');
            break;
        }
        switch (this.mobileMedia.vennMediaData.CVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.CVennDiagram, 'Mobile', '_VennC');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.mobileMedia.vennMediaData.CVennDiagram, 'Mobile', '_VennC');
            break;
        }
        combindMediaList.push(this.mobileMedia.resultMedia);
      }
      if(this.digitalMedia.resultMedia !== null){
        switch (this.digitalMedia.vennMediaData.AVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.AVennDiagram, 'Digital', '_VennA');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.AVennDiagram, 'Digital', '_VennA');
            break;
        }
        switch (this.digitalMedia.vennMediaData.BVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.BVennDiagram, 'Digital', '_VennB');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.BVennDiagram, 'Digital', '_VennB');
            break;
        }
        switch (this.digitalMedia.vennMediaData.CVennDiagram.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.CVennDiagram, 'Digital', '_VennC');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenChannelVennDiagram(this.digitalMedia.vennMediaData.CVennDiagram, 'Digital', '_VennC');
            break;
        }
        combindMediaList.push(this.digitalMedia.resultMedia);
      }

      this.formData.mediaListResult = combindMediaList;
      this.rootFormData.mediaListResult = combindMediaList;
      // 미니테이블에 필요한 데이터 만들기
      var mediaList_tmp = {};
      for(var i=0; i<this.formData.mediaListResult.length; i++){
        this.formData.mediaListResult[i].tag = '';
        for(var j=0; j< this.constFormData.length; j++){
          if(this.formData.mediaListResult[i].media == this.constFormData[j].media){

            var tmp = mediaList_tmp[this.formData.mediaListResult[i].media];
            if(tmp == null){
              mediaList_tmp[this.formData.mediaListResult[i].media] = this.formData.mediaListResult[i];
            }else{
              this.formData.mediaListResult[i].budgetLabel = '(multiple)';
              this.formData.mediaListResult[i].cpmLabel    = '(multiple)';
            }
            this.formData.mediaListResult[i].tag += '<tr>'
                        +'<td>'+ this.constFormData[j].channel +'</td>'
                        +'<td>'+ this.constFormData[j].vehicle +'</td>'
                        +'<td>'+ this.constFormData[j].targetCode +'</td>'
                        +'<td>'+ this.constFormData[j].budgetStr +'</td>'
                        +'<td>'+ this.constFormData[j].cpmStr +'</td>'
                        +'<td>'+ this.constFormData[j].eImpStr +'</td>'
                      +'</tr>';
          }
        }
      }

      var self = this;
      $(function () {
      $('#mediaTable').bootstrapTable({
            height : 400,
            data: self.formData.mediaListResult,
            onClickRow: function (row, $element) {
              $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
              self.changeChart((row.media));
            },
            detailFormatter: function(index, row) {
              var html = [];
              html.push('<table>');
              var str = '<tr><th>채널</th><th>비히클</th><th>타겟</th><th>예산</th><th>CPM</th><th>E.Imp</th></tr>';
              html.push(str);
              $.each(row, function(key, value) {
                if(key == 'tag'){
                  html.push(value);
                }
              });
              html.push('</table>');
              // join() 메서드는 배열의 모든 요소를 연결해 하나의 문자열로 만듦
              return html.join('');
            }
        });
          var first = $("#mediaTable > tbody tr:first")
          $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
        });

        this.changeChart(combindMediaList[0].media);
    },
    changeChart(mediaName) {
      switch (mediaName) {
        case 'PC':
          this.tvMediaShow=false;
          this.pcMediaShow=true;
          this.mobileMediaShow=false;
          this.digitalMediaShow=false;
          break;
        case 'Mobile':
          this.tvMediaShow=false;
          this.pcMediaShow=false;
          this.mobileMediaShow=true;
          this.digitalMediaShow=false;
          break;
        case 'Digital':
          this.tvMediaShow=false;
          this.pcMediaShow=false;
          this.mobileMediaShow=false;
          this.digitalMediaShow=true;
          break;
        default:

      }
    },
    calcTotalLevel(){
      daInteLogic.mediaInteCal(this.pcMedia.resultMedia, this.mobileMedia.resultMedia, this.digitalMedia.resultMedia, this.totalMedia.resultMedia);
      this.makeTotalLevelCode();

      switch (this.totalLevelCode) {
        case 'PM':
          this.totalMedia.reachA = this.pcMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'PC';
          this.totalMedia.reachB = this.mobileMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Mobile';
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        default:
          this.make1ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
      }

      this.completeMediaLevelCalculation = true;
    },
    makeTotalLevelCode(){
      // totalLevelCode
      if(this.pcMedia.resultMedia !== null){
        this.totalLevelCode += 'P'
      }
      if(this.mobileMedia.resultMedia !== null){
        this.totalLevelCode += 'M'
      }
      if(this.digitalMedia.resultMedia !== null){
        this.totalLevelCode += 'D'
      }
      this.$log.debug('Media Total Level Result Total Level CODE : ' + this.totalLevelCode);
    },
    // index_5-1 1screen 벤다이어그램 그리기
    make1ScreenChannelVennDiagram(mediaData, mediaName, VennName){
      // this.totalMedia = mediaData;
      var node1_id = '#mediaLevel_' + mediaName + VennName;
      document.getElementById('mediaLevel_' + mediaName + VennName).innerHTML=null;
      var reach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);
      var ALabel = mediaData.label + " " + reach1 + ' ' + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: reach1}
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
    },
    make1ScreenVennDiagram(mediaData, mediaName){
      this.totalMedia = mediaData;
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';

      var reach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);

      var ALabel = mediaName + " " + reach1 + ' ' + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: reach1}
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      // .style("stroke-opacity", 10)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '220').attr('x', '300');
    },
    // index_5-2 2screen 벤다이어그램 그리기
    make2ScreenChannelVennDiagram(mediaData, mediaName, VennName){
      var node1_id = '#mediaLevel_' + mediaName + VennName; // _VennA
      document.getElementById('mediaLevel_' + mediaName + VennName).innerHTML=null;

      var intersection = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachB)) - parseFloat(mediaData.resultMedia.reach1);

      if(intersection < 0){
        // intersection 마이너스값 발생될경우에 대한 처리 필요
        intersection = 0;
      }
      var interLabel = intersection.toFixed(2) + '%';
      var ALabel = mediaData.reachALabel + ' ' + parseFloat(mediaData.reachA).toFixed(2) + '%';
      var BLabel = mediaData.reachBLabel + ' ' + parseFloat(mediaData.reachB).toFixed(2) + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: mediaData.reachA},
                   {sets: ['1'], label : BLabel, size: mediaData.reachB},
                   {sets: ['0','1'], label : interLabel, size: intersection},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
    },
    // index_5-2 2screen 벤다이어그램 그리기
    make2ScreenVennDiagram(mediaData, mediaName){
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';
      var intersection = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachB)) - parseFloat(mediaData.resultMedia.reach1);

      if(intersection < 0){
        // intersection 마이너스값 발생될경우에 대한 처리 필요
        intersection = 0;
      }
      var interLabel = intersection.toFixed(2) + '%';
      var ALabel = mediaData.reachALabel + ' ' + parseFloat(mediaData.reachA).toFixed(2) + '%';
      var BLabel = mediaData.reachBLabel + ' ' + parseFloat(mediaData.reachB).toFixed(2) + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: mediaData.reachA},
                   {sets: ['1'], label : BLabel, size: mediaData.reachB},
                   {sets: ['0','1'], label : interLabel, size: intersection},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var inteReach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);
      var inteReach1Label = 'Total Reach : ' + inteReach1 +'%'

      var sets2 = [ {sets: ['0'], label :  ' ', size: mediaData.reachA},
                   {sets: ['1'], label : inteReach1Label, size: mediaData.reachB},
                   {sets: ['0','1'], size: intersection},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets2).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '220').attr('x', '300');
    },
    // index_5-3 3screen 벤다이어그램 그리기
    make3ScreenVennDiagram(mediaData, mediaName){
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';

      var intersection1 = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachB)) - parseFloat(mediaData.reachAB);
      var intersection2 = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachC)) - parseFloat(mediaData.reachAC);
      var intersection3 = (parseFloat(mediaData.reachB) + parseFloat(mediaData.reachC)) - parseFloat(mediaData.reachBC);
      var intersection4 = parseFloat(mediaData.reachABC) - (parseFloat(mediaData.reachA)
                          + parseFloat(mediaData.reachB) + parseFloat(mediaData.reachC)) + (intersection1 + intersection2 + intersection3);

      var outputIntersection1 = intersection1 - intersection4;
      var outputIntersection2 = intersection2 - intersection4;
      var outputIntersection3 = intersection3 - intersection4;

      intersection1 = intersection1<0?0:intersection1; // 임시방편
      intersection2 = intersection2<0?0:intersection2; // 임시방편
      intersection3 = intersection3<0?0:intersection3; // 임시방편
      intersection4 = intersection4<0?0:intersection4; // 임시방편

      var interLabel1 = intersection1.toFixed(2) + '%';
      var interLabel2 = intersection2.toFixed(2) + '%';
      var interLabel3 = intersection3.toFixed(2) + '%';
      var interLabel4 = intersection4.toFixed(2) + '%';
      var ALabel = mediaData.reachALabel + ' ' + (parseFloat(mediaData.reachA).toFixed(2)) + '%';
      var BLabel = mediaData.reachBLabel + ' ' + (parseFloat(mediaData.reachB).toFixed(2)) + '%';
      var CLabel = mediaData.reachCLabel + ' ' + (parseFloat(mediaData.reachC).toFixed(2)) + '%';
      var sets = [ {sets: ['1'], label : ALabel, size: mediaData.reachA},
                   {sets: ['2'], label : BLabel, size: mediaData.reachB},
                   {sets: ['3'], label : CLabel, size: mediaData.reachC},
                   {sets: ['1','2'], label : interLabel1, size: intersection1},
                   {sets: ['1','3'], label : interLabel2, size: intersection2},
                   {sets: ['2','3'], label : interLabel3, size: intersection3},
                   {sets: ['1','2','3'], label : interLabel4, size: intersection4},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var inteReach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);
      var inteReach1Label = 'Total Reach : ' + inteReach1 +'%'
      var sets2 = [ {sets: ['1'], label : ' ', size: mediaData.reachA},
                   {sets: ['2'], label : ' ', size: mediaData.reachB},
                   {sets: ['3'], label : inteReach1Label, size: mediaData.reachC},
                   {sets: ['1','2'], label : ' ', size: intersection1},
                   {sets: ['1','3'], label : ' ', size: intersection2},
                   {sets: ['2','3'], label : ' ', size: intersection3},
                   {sets: ['1','2','3'], label : ' ', size: intersection4},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets2).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '250').attr('x', '300');

    },
    // index_5-4 4screen 벤다이어그램 그리기
    make4ScreenVennDiagram(mediaData, mediaName){

    },
    totalLevelChartChangeFn(){
      this.totalLevelChartChange = !this.totalLevelChartChange;
      if(this.totalLevelChartChange){
        this.totalLevelChartChangeLable = '교집합 벤다이어그램'
      }else{
        this.totalLevelChartChangeLable = 'Integrated 벤다이어그램'
      }
    },
  }
}
</script>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>
<style src="../../../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
/* [시작] Help모달 버튼 CSS */
.block-options .btn {
  border-color: grey;
  border-radius: 15px;
  padding-top: 3px;
  padding-right: 10px;
  padding-left: 5px;
  max-height: 30px;
  max-width: 30px;
  text-align: center;
  background-color: #ffffff;
  /* background-color: red; */
  margin-top: 0;
  margin-bottom: 0;
}
/* [종료] Help모달 버튼 CSS */
.noData {
  margin-left:100px;margin-top:50px;font-size:24px;font-weight:600;color:#cccccc
}
</style>



// WEBPACK FOOTER //
// src/views/reach/da/result/MediaLevelResult.vue